import { AxiosResponse } from "axios";

import { api } from "api/config";
import type { IFormFeedData } from "redux/feeds/types";
import type { IAllFeedOptionsData, IFeedEndpointsResponse, IGetAllFeedsResponseData } from "./types";

const feedService = Object.freeze({
    apiUrl: (sellerId: number) => `/api/v1/yml/autocomplete/seller/${sellerId}`,
    getAllFeedOptions: (sellerId: number): Promise<AxiosResponse<IFeedEndpointsResponse<IAllFeedOptionsData>>> => {
        return api({
            url: `${process.env.REACT_APP_LEGACY_APP_URL}${feedService.apiUrl(sellerId)}`,
        });
    },
    addFeed: (data: IFormFeedData): Promise<AxiosResponse<{data: {id: number}}>> => {
        return api({
            url: `${process.env.REACT_APP_LEGACY_APP_URL}/api/v1/yml/add`,
            method: "post",
            data: JSON.stringify(data)
        });
    },
    updateFeed: (data: IFormFeedData): Promise<AxiosResponse> => {
        return api.post(`${process.env.REACT_APP_LEGACY_APP_URL}/api/v1/yml/update/${data.id}`, data)
    },
    getAllFeeds: (sellerId: number): Promise<AxiosResponse<IFeedEndpointsResponse<IGetAllFeedsResponseData[]>>> => {
        return api.get(`${process.env.REACT_APP_LEGACY_APP_URL}/api/v1/yml/get/forms/seller/${sellerId}`)
    },
    deleteFeed: (id: number): Promise<AxiosResponse> => {
        return api.post(`${process.env.REACT_APP_LEGACY_APP_URL}/api/v1/yml/delete/${id}`)
    },
    restoreFeed: (id: number): Promise<AxiosResponse> => {
        return api.post(`${process.env.REACT_APP_LEGACY_APP_URL}/api/v1/yml/restore/${id}`)
    }
});

export default feedService;